import { render, staticRenderFns } from "./Drinks.vue?vue&type=template&id=50047484&scoped=true&"
import script from "./Drinks.vue?vue&type=script&lang=js&"
export * from "./Drinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50047484",
  null
  
)

export default component.exports